// Who opens a page (and sees it in the side nav). Pure: routes.tsx declares the pages, layout/routePerms.test.ts checks them
// against the default roles and the API's permissions (task cms-quyen-hien-thi).
export type RouteAccess = {
  perm?: string;
  /** any one of these opens the page (instead of `perm`) */
  anyPerm?: string[];
  /** every one of these is needed (the page's API asks them all, e.g. requireAdmin('reports.view', 'agents.view')) */
  allPerm?: string[];
  /** only the founder role opens it (and sees it in the nav), whatever permissions another role holds */
  founderOnly?: boolean;
};

export const routeOpen = (r: RouteAccess, can: (p: string) => boolean, role?: string) => (r.founderOnly ? role === 'founder'
  : r.allPerm ? r.allPerm.every(can) : r.anyPerm ? r.anyPerm.some(can) : !r.perm || can(r.perm));
